export class CheckFarmsWithData {
    constructor(farmsDapRepository) {
      this.farmsDapRepository=farmsDapRepository
    }
    async execute(ids) {
      // ids  -> ID do Cultivar
      //Verificar se existe cultivares com ids no banco
    const farms = await this.farmsDapRepository.checkFarmsWithData(ids)
      return farms
    }
  }
  